import { useDispatch } from 'react-redux';
import { setGeneralIntegrationState, setIntegrationState } from 'actionCreators';

const useResetGlobalState = () => {
  const dispatch = useDispatch();

  const resetIntegrationErrorLog = () => {
    dispatch(
      setIntegrationState({
        team_agent_error_log: [],
        team_network_error_log: [],
      }),
    );
  };

  const resetGeneralIntegrationErrorLog = () => {
    dispatch(
      setGeneralIntegrationState({
        agent_error_log: [],
        network_error_log: [],
      }),
    );
  };

  return {
    resetIntegrationErrorLog,
    resetGeneralIntegrationErrorLog,
  };
};

export default useResetGlobalState;
